"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 233px)',
    width: 'fit-content'
};
const modalContainer = theme => ({
    padding: 24,
    height: 'auto',
    width: 'fit-content',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalConfirmContainer = theme => ({
    padding: 24,
    width: 556,
    height: 339,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white
});
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'center',
    marginBottom: 24
};
const itemAdd = {
    columnGap: 12,
    display: 'grid',
    marginBottom: 24,
    alignItems: 'center',
    gridTemplateColumns: '130px 225px',
};
const inputItem = {
    height: 27,
    borderRadius: 5
};
const buttonSave = (color) => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonTitle = {
    margin: 0,
    fontSize: 16,
    marginLeft: 8,
    fontWeight: '500',
    lineHeight: '24px'
};
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
    lineHeight: '30px',
};
const modalSubtitle = {
    margin: 0,
    fontWeight: 400,
    lineHeight: '24px',
    color: constants_1.color.softGrey,
};
const dropdownStyle = theme => ({
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const gridCard = theme => ({
    padding: 24,
    borderRadius: 10,
    backgroundColor: theme === 'dark' ? constants_1.color.gridColumnDarkAlt : constants_1.color.white,
});
const dateButtonWrapper = {
    display: 'flex',
    marginBottom: 24,
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'space-between',
};
const textDate = theme => ({
    margin: 0,
    fontSize: 14,
    fontWeight: 400,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
});
const button = theme => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    height: 40,
    padding: '12px 20px',
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
});
const buttonFont = {
    fontSize: '16px',
    fontWeight: 'normal',
    margin: 0,
    marginLeft: 8
};
exports.default = {
    button,
    itemAdd,
    textDate,
    gridCard,
    inputItem,
    gridHeight,
    modalTitle,
    buttonSave,
    buttonFont,
    modalHeader,
    buttonTitle,
    buttonDelete,
    modalSubtitle,
    dropdownStyle,
    modalContainer,
    dateButtonWrapper,
    modalConfirmContainer,
};
